// src/features/auth/useWriteProfileLanguage.ts
import { useCallback } from 'react'
import { useAppSelector } from '@/store/hooks'
import type { Lang } from '@/types/lang'
import { usePatchMeMutation } from './authApi'
import { selectAuthToken } from './selectors'

/**
 * Пишет язык интерфейса в профиль (`PATCH /users/me`) — общий идиом,
 * которым раньше дословно (и раздельно) владели LanguageToggle и
 * ProfileLanguageSync.
 *
 * Гейт по токену обязателен: LanguageToggle рендерится и на экране логина
 * (`variant="auth"`), где токена нет по определению — без гейта каждое
 * переключение языка гостем стреляло бы гарантированным 401, а обработчик
 * в src/api/client.ts на 401 дёргает clearAuthTokens(). Тост при этом
 * гасится (401 — silent, см. errorToastMiddleware), поэтому без гейта баг
 * был бы тихим.
 *
 * Ошибку глотаем намеренно: интерфейс уже переключился, для автора действие
 * удалось. Следующая смена языка или сверка на заходе попробует снова.
 */
export const useWriteProfileLanguage = () => {
  const hasToken = useAppSelector((s) => Boolean(selectAuthToken(s)))
  const [patchMe] = usePatchMeMutation()

  return useCallback(
    (languageCode: Lang) => {
      if (!hasToken) return
      void patchMe({ languageCode })
        .unwrap()
        .catch(() => {})
    },
    [hasToken, patchMe],
  )
}
